import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltipMessage: {
		id: 'autodev.agent-picker.good-rank-indicator-tooltip-message',
		defaultMessage: 'This is likely to be a good fit for this task',
		description:
			'The tooltip message for the good rank indicator, explaining the agent is likely to generate good code.',
	},
});
